export const isWavinOrOrbiaEmail = (email: string) => {
  const domain = email.trim().toLowerCase().split('@')[1];
  return domain === 'wavin.com' || domain === 'orbia.com';
};

export const isOrbiaEmail = (email: string) => {
  const domain = email.trim().toLowerCase().split('@')[1];
  return domain === 'orbia.com';
};
